import { render, staticRenderFns } from "./tableOwnTasks.vue?vue&type=template&id=0261a65c&scoped=true"
import script from "./tableOwnTasks.vue?vue&type=script&lang=js"
export * from "./tableOwnTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0261a65c",
  null
  
)

export default component.exports